import iconLose from 'assets/images/eventBoatRacingT10/ic-lose.webp'
import iconCup from 'assets/images/eventBoatRacingT10/ic-win.webp'
import iconBoat from 'assets/images/eventBoatRacingT10/iconBoat.png'
import iconRank from 'assets/images/eventBoatRacingT10/podium.webp'
import iconHomeImage from 'assets/images/eventBoatRacingT10/prize.webp'
import iconRule from 'assets/images/eventBoatRacingT10/rules.webp'
import textHomeImage from 'assets/images/eventBoatRacingT10/text_event.webp'
import LoginWebModal from 'components/Modal/LoginWebModal'
import NotificationNew from 'components/Notification/Notification'
import Shop from 'pages/HomeNew/components-new/Shop'
import { useCheckSub } from 'dataLayer/game'
import { getUserQuery } from 'dataLayer/user'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { getUserinfo } from 'utils/localStorage'
import NotificationModal from './NotificationModal'

export default function BoatRacingHomeT10({ onPressTab }) {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const { data: user } = useQuery(getUserQuery())
	const DOMAIN_UID = process.env.REACT_APP_DOMAIN_UID
	const CLIENTID = process.env.REACT_APP_CLIENTID
	const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI
	const [open, setOpen] = useState(false)
	const [openShopPage, setOpenShopPage] = useState(false)
	const [dataCheckSub, setDataCheckSub] = useState()
	const [modalShowLoginPass, setModalShowLoginPass] = useState(false)
	const isLoginType = process.env.REACT_APP_IS_LOGIN;
	const [openModalWinLostT102025, setOpenModalWinLostT102025] = useState(false);
	const userInfo = getUserinfo()

	const { mutate } = useCheckSub(data => {
		if (data?.responseCode === '200') {
			setDataCheckSub(data?.data)
			const storagePackageKey = `isPopupShownPackage_T10-2025`;
			const alreadyShownPackage = localStorage.getItem(storagePackageKey);

			if (!alreadyShownPackage) {
				localStorage.setItem(storagePackageKey, "true");
				!!userInfo && data?.data?.isSub === false && setOpenModalWinLostT102025(true)
			}
		}
	})

	useEffect(() => {
		!!user && !!userInfo && mutate({
			location: 'BEAT_MOUSE',
			from: 'auto',
			...(localStorage.getItem('laoapp') === 'superApp' && {
				grant_type: 'login_super_app',
			}),
		})
	}, [user])

	// Shop (iframe) gửi SEND_DATA khi đăng ký gói thành công => gọi lại check-sub và đóng popup shop
	useEffect(() => {
		const handleMessage = (event) => {
			if (event.data?.type === 'SEND_DATA') {
				mutate({
					location: 'BEAT_MOUSE',
					from: 'auto',
					...(localStorage.getItem('laoapp') === 'superApp' && {
						grant_type: 'login_super_app',
					}),
				})
				setOpenShopPage(false)
			}
		}
		window.addEventListener('message', handleMessage)
		return () => window.removeEventListener('message', handleMessage)
	}, [])

	const handleStart = () => {
		if (user) {
			// dataCheckSub?.isSub ? window.location.href = '/room/1' : setOpen(!open)
			dataCheckSub?.isSub ? navigate('/', { state: { autoPlay: true } }) : setOpen(!open)
			// dataCheckSub?.isSub ? window.location.href = `http://192.168.100.201:3001/room/1` : setOpen(!open)
		} else {
			if (isLoginType === "POPUP") {
				setModalShowLoginPass(true);
			} else if (isLoginType === "LINK") {
				window.location.href = `${DOMAIN_UID}?client_id=${CLIENTID}&redirect_uri=${REDIRECT_URI}&use_callback_uri=true`
			}
		}
	}

	return (
		<>
			<div className='container-boat-racing-home-t10'>
				<img src={textHomeImage} alt="text-home" className='text-home' />
				<img src={iconHomeImage} alt="image-icon-home" className='image-icon-home' />
				<div className='home-action'>
					<button className='btn-button' onClick={handleStart}>
						{t('event.event_boa_racing_t10.play_now')}
					</button>
				</div>
				<div className='mission'>
					<div className='image-mission'>
						<span className='mission-top'>
							<span>{t('event.event_boa_racing_t10.mission')}</span>
						</span>
						<div className='cup'>
							<div className='cup-content'>
								<img src={iconCup} alt="image-icon-cup" className='image-icon-cup' />
								<div>
									<p>
										{t('event.event_boa_racing_t10.win_a_match')}
									</p>
									<span className='text-highlight'>
										{t('event.event_boa_racing_t10.randomly_receive_3_5')}
									</span>
								</div>
							</div>
							<div className='image-boat'>
								3 - 5<img src={iconBoat} alt="image-icon-boat" className='image-icon-boat' />
							</div>
						</div>

						<div className='lose'>
							<div className='lose-content'>
								<img src={iconLose} alt="image-icon-lose" className='image-icon-lose' />
								<div>
									<p>
										{t('event.event_boa_racing_t10.lose_a_match')}
									</p>
									<span className='text-highlight'>
										{t('event.event_boa_racing_t10.receive')}
									</span>
								</div>
							</div>
							<div className='image-boat'>
								1x<img src={iconBoat} alt="image-icon-boat" className='image-icon-boat' />
							</div>
						</div>
						<span className='text-mission'>
							{t('event.event_boa_racing_t10.accumulate_boats_to_climb_the_leaderboard')}
						</span>
					</div>
				</div>

				<div className='home-rank' onClick={() => onPressTab?.('RANK')}>
					<img src={iconRank} alt="image-icon-rank" className='image-icon-rank' />
					<p>
						{t('event.event_boa_racing_t10.tab.rank')}
					</p>
				</div>
				<div className='home-rules' onClick={() => onPressTab?.('DETAIL')}>
					<img src={iconRule} alt="image-icon-rules" className='image-icon-rules' />
					<p>
						{t('event.event_boa_racing_t10.rules')}
					</p>
				</div>
			</div>

			<NotificationModal
				show={open}
				title={t('event.event_boa_racing_t10.notice')}
				content={t('event.event_boa_racing_t10.please_subscribe_to_the_dailysub_package_to_participate_in_the_boun_suang_heua_event')}
				handleCancel={() => setOpen(!open)}
				footer={<>
					<button onClick={() => {
						// sessionStorage.setItem("fromHome", "true");
						// window.location.href = dataCheckSub?.urlWebView;
						// window.open('http://192.168.100.201:3001/', "_blank")
						setOpen(false)
						setOpenShopPage(true)
					}} className='button-continue' style={{ width: "50%", }}>
						{t('event.event_boa_racing_t10.buy_package')}
					</button>
				</>
				}
			/>

			{/* show thắng chưa mua gói */}
			<NotificationModal
				show={openModalWinLostT102025}
				title={t('event.event_boa_racing_t10.notice')}
				content={t('event.event_boa_racing_t10.you_need_to_subscribe_to_the_dailysub_package_to_participate_in_the_boun_suang_heua_event_and_receive_many_valuable_rewards')}
				footer={
					<>
						<button onClick={() => {
							navigate('/event-boat-racing')
							setOpenModalWinLostT102025(false)
						}} className='button-event'>
							<img src={iconBoat} alt="iconBoat" className='icon-boat-event' />
							{t('event.event_boa_racing_t10.visit_event')}
						</button>
						<button onClick={() => {
							// if (dataCheckSub?.urlWebView) {
							// 	window.location.href = dataCheckSub?.urlWebView;
							// }
							setOpenModalWinLostT102025(false)
							setOpenShopPage(true)
						}}
							className='button-continue'>
							{t('event.event_boa_racing_t10.buy_package')}
						</button>
					</>}
				handleCancel={() => setOpenModalWinLostT102025(false)}
			/>
			{/* show page shop */}
			<NotificationNew
				show={openShopPage}
				title={<h2 className='title-shop-new'>{t('shop')}</h2>}
				content={
					<Shop
						url={dataCheckSub?.urlWebView || userInfo?.urlWebView}
						onSuccess={() => { }}
					/>
				}
				className='shop-page-new'
				handleCancel={() => setOpenShopPage(false)}
			/>
			<LoginWebModal
				modalShowLoginPass={modalShowLoginPass}
				setModalShowLoginPass={setModalShowLoginPass}
			/>
		</>
	)
}
